import { render } from "./PunishmentType.vue?vue&type=template&id=14b50079&ts=true"
import script from "./PunishmentType.vue?vue&type=script&lang=ts"
export * from "./PunishmentType.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__